<template>
  <li >
    <div v-if="item.template === 'folder'">
      <div class="showScript" v-on:click="showHidden = !showHidden">{{item.title}}</div>
      <OperatorScriptLayout  :parentID="item.id" :sourceId="sourceId" v-show="showHidden"></OperatorScriptLayout>
    </div>
    <div v-if="item.template === 'faq'">
      <div class="showScript"  v-on:click="showHidden = !showHidden">{{item.title}}</div>
      <div v-html="item.content"  v-show="showHidden" class="content"></div>
    </div>
    <div v-if="item.template === 'pdf'">
      <div class="showScript"  v-on:click="showHidden = !showHidden">{{item.title}}</div>
      <a :href="item.content" v-show="showHidden" target="_blank">Открыть в новой вкладе</a>
      <iframe :src="item.content" frameborder="0"  v-show="showHidden"></iframe>
    </div>
  </li>
</template>

<script>
  export default {
    name: "operatorScriptItem",
    data(){
      return {
        showHidden:false,
      }
    },
    components:{
      OperatorScriptLayout: () => import('@/components/OperatorScript/OperatorScriptLayout'),
    },
    props:{
      sourceId:{
        type:String,
        default:0,
      },
      item:{
        type:Object,
        default:()=>{
          return {};
        }
      }
    }
  }
</script>

<style scoped>
  .showScript{cursor: pointer;}
  iframe {width: 100%;height: 80vh}
  ul li{list-style: decimal;padding: 3px 0;}
  .content{padding: 5px 0;}
</style>
